import QysPdfViewer from './components/pdf-container.vue';
export default QysPdfViewer;